import React from 'react';
import MediaModal from '../media/MediaModal';

const ConvertPortalToMediaModal = ({ open, onClose, onSave, portal }) => {
  const initialMediaTypeId = portal?.correspondingMedia?.mediaTypeId ?? 1;

  const initialTitlePairs = portal?.localizedPairs?.values?.length
    ? portal.localizedPairs.values.map((v) => ({ localeId: v.localeId, value: v.value }))
    : undefined;

  const initialLinkPairs = portal?.correspondingMedia?.linkLocalizations?.length
    ? portal.correspondingMedia.linkLocalizations.map((l) => ({ localeId: l.localeId, mediaLink: l.mediaLink }))
    : undefined;

  return (
    <MediaModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      initialMediaTypeId={initialMediaTypeId}
      initialTitlePairs={initialTitlePairs}
      initialLinkPairs={initialLinkPairs}
      title="Convert to Media"
      subtitle="Title and image are carried over — add a description to finish."
      saveLabel="Convert to Media"
    />
  );
};

export default ConvertPortalToMediaModal;
